// Service-worker update bus — module-level, same pattern as the sync bus in
// pb.js so it can't couple to React renders. index.js reports a waiting
// worker via swUpdateAvailable(); App subscribes with onSwUpdate() to show
// the "Update available" toast; the toast's Refresh button calls applyUpdate().
let _waiting = null;
let _listeners = [];

export function swUpdateAvailable(registration) {
  const w = registration && registration.waiting;
  if (!w) return;
  _waiting = w;
  _listeners.forEach(fn => { try { fn(); } catch {} });
}

export function onSwUpdate(fn) {
  _listeners.push(fn);
  if (_waiting) { try { fn(); } catch {} }
  return () => { _listeners = _listeners.filter(f => f !== fn); };
}

// Activate the waiting worker and reload once it takes control. Safe to call
// with no update pending.
export function applyUpdate() {
  if (!_waiting) return;
  if (navigator.serviceWorker) {
    navigator.serviceWorker.addEventListener(
      "controllerchange", () => window.location.reload(), { once: true }
    );
  }
  _waiting.postMessage({ type: "SKIP_WAITING" });
  _waiting = null;
}

// Test hook — reset module state between tests.
export function _resetSwUpdateForTests() { _waiting = null; _listeners = []; }
